<template>
  <div class="contact-wrapper">
    <div class="intro-container">
      <div class="intro-item">
        <div class="intro-con">
          <div class="content">
            <div class="contact-item">联系方式：0571-81968150</div>
            <div class="contact-item">联系地址：杭州市滨江区联慧街6号矽力杰大厦</div>
            <div class="contact-item">
              <!--<iframe class="map" src="https://ditu.baidu.com/?poiShareUid=2f64b73d19436f13213bf225"></iframe>-->
              <iframe class="map" src="static/address.html"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .contact-item {
    padding: @spacing-col-sm 0;
    font-weight: 700;
    .map {
      border: none;
      width: 100%;
      height: 500px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/contact/contact.vue